// extracted by mini-css-extract-plugin
export var activityContainer = "_nf-0";
export var typingIndicatorContainer = "_nf-1";
export var typingIndicatorDot = "_nf-2";
export var wave = "_nf-3";